import React from 'react'
import { useTheme } from '@material-ui/core'
import {
  CircularProgress,
  Grid,
  Typography,
  TextField,
  Divider,
  InputAdornment,
  Tooltip,
  Fab,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import PhotoIcon from '@material-ui/icons/Photo'
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt'
import AddIcon from '@material-ui/icons/Add'
import { Editor } from '@tinymce/tinymce-react'

import { Page, SelecionarData, CustomButton } from 'components'
import { HeaderEdicaoExame } from '../components/HeaderEdicaoExame'
import constants from 'utils/constants'
import { useStyles } from './EditorDocumento.styles'
import { useEditorDocumento } from './useEditorDocumento'

export const EditorDocumento = (props) => {
  const { route } = props
  const tipoExame = props.location.state?.tipoExame
  const theme = useTheme()
  const isDark = theme.palette.type === 'dark'
  const classes = useStyles()

  const {
    documentoState,
    setDocumentoState,
    fotosDocumentoState,
    alertaErroTipoImagem,
    openUpload,
    setOpenUpload,
    uploadedImages,
    processandoUploadImagens,
    processandoConfirmacaoImagens,
    formAnaliseNecropapiloscopica,
    exibirFormExameNecropapiloscopico,
    arrayFiliacao,
    isFormularioInvalido,
    css,
    templates,
    processandoEditor,
    exameRealizado,
    editorRef,
    handleValorChange,
    handleAdicionarFiliacao,
    getResultadoLabel,
    handleImageChange,
    handleChangeLegenda,
    handleConfirmUploadImagens,
    handleConfirmUploadImagensFinalDocumento,
    handleCancelarUploadImagens,
    setDataColeta,
    updateFigcaption,
    snackBar
  } = useEditorDocumento(route, tipoExame)

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <HeaderEdicaoExame
        titulo={`${route.secao}`}
        overline={route.secao}
        isEditorDocumento
        documentoState={documentoState}
        fotosDocumentoState={fotosDocumentoState}
        openUpload={openUpload}
        setOpenUpload={setOpenUpload}
        errata={route.errata}
        isFormularioInvalido={isFormularioInvalido}
        formAnaliseNecropapiloscopica={formAnaliseNecropapiloscopica}
      />
      <Grid className={classes.alert} item md={12} sm={12} xs={12}>
        {alertaErroTipoImagem &&
          snackBar({
            variant: 'error',
            message: 'Tipo de arquivo não suportado. Selecione um arquivo .jpg',
          })}
      </Grid>
      <div className={classes.container}>
        {processandoEditor ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <div className={classes.content}>
            {/* Se o documento for uma ERRATA e o tipo do exame for NECROPAPILOSCOPICO o formulário abaixo é exibido para atualização dos dados de identificação do cadáver */}
            <Grid container spacing={2}>
              {route.errata && exibirFormExameNecropapiloscopico && (
                <Grid item xs={12} className={classes.formNecropapiloscopico}>
                  <Grid item xs={12}>
                    <Typography variant="h5">DADOS DE IDENTIFICAÇÃO</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid container className={classes.corpoFormulario} spacing={2}>
                    <Grid container item xs={12} className={classes.item}>
                      <Grid item md={6} sm={6} xs={12}>
                        <AutocompleteNative
                          name="resultado"
                          noOptionsText="Sem informações"
                          options={[
                            'IDENTIFICADO_DOCUMENTO',
                            'NAO_IDENTIFICADO_DOCUMENTO',
                            'IDENTIFICADO_SISTEMA',
                            'NAO_IDENTIFICADO_SISTEMA',
                            'NAO_IDENTIFICADO_FALTA_DOCUMENTO'
                          ]}
                          value={formAnaliseNecropapiloscopica.formState.values.resultado || null}
                          onChange={(event, newValue) => {
                            formAnaliseNecropapiloscopica.handleChangeNewValueByNameProperty(event, newValue, 'resultado')
                          }}
                          getOptionLabel={(option) => getResultadoLabel(option)}
                          renderOption={(option) => getResultadoLabel(option)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="RESULTADO DA ANÁLISE"
                              error={formAnaliseNecropapiloscopica.hasErrorWithoutTouch('resultado')}
                              helperText={
                                formAnaliseNecropapiloscopica.hasError('resultado')
                                  ? formAnaliseNecropapiloscopica.formState.errors.resultado[0]
                                  : null
                              }
                              required
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item xs={12} className={classes.item}>
                      <Grid item md={6} sm={6} xs={12}>
                        <TextField
                          fullWidth
                          label="NÚMERO PROTOCOLO ABIS"
                          name="numeroProtocolo"
                          onChange={formAnaliseNecropapiloscopica.handleChange}
                          value={formAnaliseNecropapiloscopica.formState.values.numeroProtocolo || ''}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item xs={12} className={classes.item}>
                      <Grid item md={6} sm={6} xs={12}>
                        <AutocompleteNative
                          name="tipoDocumento"
                          noOptionsText="Sem informações"
                          options={[
                            'REGISTRO CIVIL',
                            'PRONTUÁRIO CIVIL',
                            'PRONTUÁRIO DE IDENTIFICAÇÃO CRIMINAL',
                            'CARTEIRA DE TRABALHO',
                            'CARTEIRA PROFISSIONAL',
                            'PASSAPORTE',
                            'CARTEIRA DE IDENTIFICAÇÃO FUNCIONAL',
                            'OUTRO'
                          ]}
                          value={formAnaliseNecropapiloscopica.formState.values.tipoDocumento || null}
                          onChange={(event, newValue) => {
                            formAnaliseNecropapiloscopica.handleChangeNewValueByNameProperty(event, newValue, 'tipoDocumento')
                          }}
                          getOptionLabel={(option) => option}
                          renderOption={(option) => option}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="TIPO DO DOCUMENTO CONFRONTADO"
                              error={formAnaliseNecropapiloscopica.hasError('tipoDocumento')}
                              helperText={
                                formAnaliseNecropapiloscopica.hasError('tipoDocumento')
                                  ? formAnaliseNecropapiloscopica.formState.errors.tipoDocumento[0]
                                  : null
                              }
                              required
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2} justifyContent="space-between">
                      <Grid className={classes.item} item md={6} sm={6} xs={12}>
                        <TextField
                          fullWidth
                          label="Nº DO DOCUMENTO"
                          name="numeroDocumento"
                          onChange={formAnaliseNecropapiloscopica.handleChange}
                          value={formAnaliseNecropapiloscopica.formState.values.numeroDocumento || ''}
                          error={formAnaliseNecropapiloscopica.hasError('numeroDocumento')}
                          helperText={
                            formAnaliseNecropapiloscopica.hasError('numeroDocumento')
                              ? formAnaliseNecropapiloscopica.formState.errors.numeroDocumento[0]
                              : null
                          }
                          required
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid className={classes.item} item md={5} sm={5} xs={12}>
                        <TextField
                          fullWidth
                          label="ÓRGÃO EMISSOR"
                          name="orgaoEmissorDocumento"
                          onChange={formAnaliseNecropapiloscopica.handleChange}
                          value={formAnaliseNecropapiloscopica.formState.values.orgaoEmissorDocumento || ''}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid className={classes.item} item xs={12}>
                      <TextField
                        fullWidth
                        label="NOME COMPLETO"
                        name="nome"
                        onChange={formAnaliseNecropapiloscopica.handleChange}
                        value={formAnaliseNecropapiloscopica.formState.values.nome || ''}
                        error={formAnaliseNecropapiloscopica.hasError('nome')}
                        helperText={
                          formAnaliseNecropapiloscopica.hasError('nome')
                            ? formAnaliseNecropapiloscopica.formState.errors.nome[0]
                            : null
                        }
                        required
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid className={classes.groupFiliacao} alignItems="center" container item xs={12} justifyContent="space-between">
                      <Grid className={classes.item} item xs={12}>
                        {arrayFiliacao.map((input, index) => (
                          <TextField
                            key={input}
                            error={formAnaliseNecropapiloscopica.hasError(`${input}`)}
                            fullWidth
                            helperText={
                              formAnaliseNecropapiloscopica.hasError(`${input}`)
                                ? formAnaliseNecropapiloscopica.formState.errors[`${input}`][0]
                                : null
                            }
                            className={classes.inputForm}
                            label={`FILIAÇÃO (${index + 1})`}
                            name={input}
                            onChange={formAnaliseNecropapiloscopica.handleChange}
                            value={formAnaliseNecropapiloscopica.formState.values[input] || ''}
                            variant="outlined"
                            margin="normal"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              endAdornment: index + 1 === arrayFiliacao.length && (
                                <InputAdornment position="start">
                                  <Tooltip title="Adicionar filiação">
                                    <Fab
                                      color="primary"
                                      size="small"
                                      onClick={() => handleAdicionarFiliacao()}
                                      className={classes.botaoAddFiliacao}
                                    >
                                      <AddIcon />
                                    </Fab>
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ))}
                      </Grid>
                    </Grid>

                    <Grid item md={6} sm={6} xs={12} className={classes.item}>
                      <TextField
                        fullWidth
                        label="NATURALIDADE"
                        name="naturalidade"
                        onChange={formAnaliseNecropapiloscopica.handleChange}
                        value={formAnaliseNecropapiloscopica.formState.values.naturalidade || ''}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid item container md={5} sm={5} xs={12} className={classes.item}>
                      <Grid item xs={12}>
                        <Typography variant="body2">SEXO</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl component="fieldset" fullWidth>
                          <RadioGroup
                            aria-label="sexo"
                            name="sexo"
                            value={formAnaliseNecropapiloscopica.formState.values.sexo || 'DESCONHECIDO'}
                            onChange={formAnaliseNecropapiloscopica.handleChange}
                            style={{ display: 'flex', flexDirection: 'row' }}
                          >
                            <FormControlLabel value="MASCULINO" control={<Radio />} label={<Typography variant="body2">MASCULINO</Typography>} />
                            <FormControlLabel value="FEMININO" control={<Radio />} label={<Typography variant="body2">FEMININO</Typography>} />
                            <FormControlLabel value="DESCONHECIDO" control={<Radio />} label={<Typography variant="body2">DESCONHECIDO</Typography>} />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid className={classes.item} item xs={12}>
                      <Grid item md={6} sm={6} xs={12}>
                        <SelecionarData
                          dataBD={formAnaliseNecropapiloscopica.formState.values.dataNascimento}
                          withoutTime
                          name="dataNascimento"
                          callback={setDataColeta}
                          label="DATA DE NASCIMENTO"
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12}>
                <input
                  type="file"
                  multiple
                  accept="image/*, .jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .heic, .HEIC"
                  id="file-input"
                  className={classes.uploadButton}
                  onChange={handleImageChange}
                />
                <label htmlFor="file-input">
                  <CustomButton
                    component="span"
                    colorType="secondary"
                    className={classes.customUploadButton}
                    variant="contained"
                    startIcon={<PhotoIcon />}
                  >
                    Selecionar fotos para upload
                  </CustomButton>
                </label>
              </Grid>

              {processandoUploadImagens && (
                <Grid item xs={12} className={classes.carregando}>
                  <CircularProgress disableShrink />
                </Grid>
              )}

              {uploadedImages.length > 0 && (
                <Grid item xs={12} style={{ padding: '20px', width: '100%' }}>
                  <Grid container spacing={3} style={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
                    {uploadedImages.map((image, index) => (
                      <Grid item key={image.id} xs={12} sm={6} md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                          <img
                            src={`${process.env.REACT_APP_API_DNS}/arquivo/exame/open/${image.id}`}
                            alt={`Imagem ${index}`}
                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                          />
                        </div>
                        <TextField
                          required 
                          error={uploadedImages[index].error}
                          fullWidth
                          label="Legenda da Imagem"
                          variant="outlined"
                          onChange={(e) => handleChangeLegenda(e.target.value, index)}
                          value={uploadedImages[index].caption}
                        />
                      </Grid>
                    ))}
                  </Grid>
                  <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
                    <Grid item>
                      <CustomButton variant="contained" colorType="secondary" onClick={handleCancelarUploadImagens}>
                        Cancelar
                      </CustomButton>
                    </Grid>
                    <Grid item style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <CustomButton
                        startIcon={<SystemUpdateAltIcon />}
                        colorType="primary"
                        variant="contained" sigepftppasswd
                        className={classes.botaoAnexar}
                        onClick={handleConfirmUploadImagens}
                        isLoading={processandoConfirmacaoImagens}
                      >
                        ANEXAR IMAGENS (POSIÇÃO DO CURSOR)
                      </CustomButton>
                      <CustomButton
                        startIcon={<SystemUpdateAltIcon />}
                        colorType="primary"
                        variant="contained"
                        className={classes.botaoAnexar}
                        onClick={handleConfirmUploadImagensFinalDocumento}
                        isLoading={processandoConfirmacaoImagens}
                      >
                        ANEXAR IMAGENS (FINAL DO DOCUMENTO)
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Grid className={classes.item} item xs={12}>
                {exameRealizado?.id && css && (
                  <Editor
                    key={isDark ? 'dark-editor' : 'light-editor'}
                    tinymceScriptSrc="/tinymce/tinymce.min.js"
                    licenseKey="gpl"
                    // eslint-disable-next-line no-return-assign
                    onInit={(_, editor) => (editorRef.current = editor)}
                    initialValue={route.errata ? constants.TEXTO_ERRATA_DEFAULT : exameRealizado.textoDocumento ? exameRealizado.textoDocumento : ''}
                    onChange={handleValorChange}
                    init={{
                      setup(ed) {
                        ed.on('BeforeSetContent', function e(evt) {
                          if (evt.content) {
                            evt.content = evt.content.replace(/<p style=['"]page-break-after:\s*always;?['"]>(?:&nbsp;|\s)*<\/p>/gi, '<p style="page-break-after: always;">&nbsp;</p>')
                          }
                        })

                        const elementosNonEditableInicial = []
                        let elementosNonEditableAtual = []

                        const addNonEditableElement = (element) => {
                          if (element.classList && element.classList.contains('mceNonEditable')) {
                            elementosNonEditableInicial.push(element)
                          }
                          if (element.children) {
                            for (let i = 0; i < element.children.length; i += 1) {
                              addNonEditableElement(element.children[i])
                            }
                          }
                        }
                        const countNonEditableElement = (element) => {
                          if (element.classList && element.classList.contains('mceNonEditable')) {
                            elementosNonEditableAtual.push(element)
                          }
                          if (element.children) {
                            for (let i = 0; i < element.children.length; i += 1) {
                              countNonEditableElement(element.children[i])
                            }
                          }
                        }

                        ed.on('LoadContent', function e() {
                          addNonEditableElement(ed.dom.getRoot())
                        })

                        ed.on('SelectionChange', function e() {
                          elementosNonEditableAtual = []
                          countNonEditableElement(ed.dom.getRoot())

                          if (elementosNonEditableAtual.length < elementosNonEditableInicial.length) {
                            ed.undoManager.undo()
                            setDocumentoState(ed.getContent())
                          }
                        })
                        ed.ui.registry.addButton('updateCounter', {
                          icon: 'reload',
                          tooltip: 'Atualizar contagem de fotos e tabelas',
                          onAction: () => {
                            updateFigcaption(ed)
                          },
                          context: 'any',
                        })
                      },
                      style_formats_merge: true,
                      browser_spellcheck: true,
                      image_caption: true,
                      remove_script_host: false,
                      relative_urls: false,
                      document_base_url: `${process.env.REACT_APP_API_URL_IMAGE}/arquivo/exame/open/`,
                      height: 800,
                      pagebreak_separator: '<p style="page-break-after: always;">&nbsp;</p>',
                      menubar: false,
                      language: 'pt_BR',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount noneditable pagebreak',
                        'template'
                      ],
                      toolbar: 'undo redo | formatselect table | bold italic underline forecolor backcolor removeformat | align | bullist numlist | pagebreak outdent indent template | updateCounter',
                      templates: templates,
                      skin: isDark ? 'oxide-dark' : 'oxide',
                      content_css: 'default',
                      content_style: css + ' body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background-color: #fff !important; color: #000 !important; }',
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    </Page>
  )
}
